import api from "../../Services/api";

export const deleteUser = async (userId) => {
  const response = await api.delete(`/users/${userId}`, {
    data: {},
  });
  return response;
};

export const updateUser = async (userId, userData) => {
  const response = await api.put(`/users/${userId}`, userData);
  return response;
};
export const fetchUsers = async () => {
  const response = await api.get("/users", {
    data: {},
  });

  return response.data.data.users;
};

export const addUser = async (newUser) => {
  const response = await api.post("/auth/register", newUser, {});
  return response;
};

export const exportToSkeyechartSwitch = async (userId) => {
  const response = await api.put(`/users/${userId}/toggle-export`, {
    data: {},
  });
  return response;
};

export const saveNewUser = async (
  newUser,
  toast,
  setAddUserDialogVisible,
  setNewUser,
  refreshUsers
) => {
  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  if (
    !newUser.email ||
    !newUser.username ||
    !newUser.password ||
    !newUser.confirmPassword ||
    newUser.roles.length === 0
  ) {
    toast.current.show({
      severity: "warn",
      summary: "Validation",
      detail: "All fields are required",
      life: 3000,
    });
    return;
  }

  if (!isValidEmail(newUser.email)) {
    toast.current.show({
      severity: "warn",
      summary: "Validation",
      detail: "Invalid email format",
      life: 3000,
    });
    return;
  }

  if (newUser.password.length < 6) {
    toast.current.show({
      severity: "warn",
      summary: "Validation",
      detail: "Passwords should be at least 6 characters long",
      life: 3000,
    });
    return;
  }

  if (newUser.password !== newUser.confirmPassword) {
    toast.current.show({
      severity: "warn",
      summary: "Validation",
      detail: "Passwords do not match",
      life: 3000,
    });
    return;
  }

  try {
    const response = await addUser(newUser);

    if (response.status === 200 || response.status === 201) {
      // Close the dialog and reset the form
      setAddUserDialogVisible(false);
      setNewUser({
        email: "",
        username: "",
        password: "",
        confirmPassword: "",
        roles: [],
      });

      // Refresh users without reloading the page
      await refreshUsers();

      // Show success message
      toast.current.show({
        severity: "success",
        summary: "Success",
        detail: "User added successfully",
        life: 3000,
      });
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message;

    if (errorMessage) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: errorMessage,
        life: 3000,
      });
    } else {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Failed to add user",
        life: 3000,
      });
    }
  }
};
